const KEY_PREFIX = "waterra:";

export interface KeyValueStore {
  read(key: string): string | null;
  write(key: string, value: string): void;
  remove(key: string): void;
}

export function prefixedKey(key: string): string {
  return `${KEY_PREFIX}${key}`;
}

export function memoryStore(): KeyValueStore {
  const data = new Map<string, string>();
  return {
    read: (key) => data.get(key) ?? null,
    write: (key, value) => {
      data.set(key, value);
    },
    remove: (key) => {
      data.delete(key);
    },
  };
}

const browserStore: KeyValueStore = {
  read(key) {
    try {
      return globalThis.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  write(key, value) {
    try {
      globalThis.localStorage.setItem(key, value);
    } catch {
      // best-effort: storage may be full, disabled, or unavailable
    }
  },
  remove(key) {
    try {
      globalThis.localStorage.removeItem(key);
    } catch {
      // best-effort
    }
  },
};

let cachedDefault: KeyValueStore | undefined;

export function getDefaultStore(): KeyValueStore {
  cachedDefault ??= canUseLocalStorage() ? browserStore : memoryStore();
  return cachedDefault;
}

function canUseLocalStorage(): boolean {
  try {
    const probe = `${KEY_PREFIX}__probe__`;
    globalThis.localStorage.setItem(probe, "1");
    globalThis.localStorage.removeItem(probe);
    return true;
  } catch {
    return false;
  }
}
